<template>
  <div class="diary-date">
    <span v-if="!diary_date">Not Set</span>
    <span v-if="diary_date">{{ diary_date }}</span>
    <a @click="initAndShow()" class="label label-default" href="#"><i class="fa fa-fw fa-calendar"></i></a>

    <modal :id="modalId" title="Diary Date">
      <form :id="formId" method="POST" :action="action" @submit="submit">
        <input type="hidden" name="diary_date" v-model="date">

        <div class="form-group row">
          <label class="col-sm-3 col-form-label">Current Diary Date:</label>
          <div class="col-sm-9">
            <div class="mb-1 form-control text-center form-control-plaintext">
              <span v-if="!diary_date" class="label label-danger">Not Set</span>
              <span v-if="diary_date"><i class="fa fa-calendar"></i> {{ diary_date }}</span>
            </div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-3 col-form-label">New Diary Date:</label>
          <div class="col-sm-9">
            <div v-if="!enableDatePicker" class="mb-1 form-control text-center form-control-plaintext">
              <i v-if="date" class="fa fa-calendar"></i>
              <span v-else>Select a date <i class="fa fa-level-down"></i></span>
              {{ date }}
            </div>
            <div v-else class="mb-1">
              <datepicker
                v-model="newDate"
                ref="datepicker"
                :min-date="minDate"
                :disabled="!enableDatePicker"
                @closed="selectDate()"
                placeholder="Select a date">
              </datepicker>
            </div>

            <div class="btn-group btn-group-sm d-flex" role="group" data-toggle="buttons">
              <button v-for="days in dayOptions" class="btn btn-info btn-sm" @click.prevent="addDays(days)">
                <input type="radio" name="days"> {{ days }}d
              </button>
              <button class="btn btn-info btn-sm" @click.prevent="activateDatePicker()">
                <input type="radio" name="days"> Other
              </button>
            </div>
          </div>
        </div>

        <template v-if="diary_date">

          <!-- Diary date change reason -->
          <div class="form-group row">
            <label for="ddReasonId" class="col-sm-3 col-form-label">Diary date change reason</label>
            <div class="col-sm-9">
              <select name="dd_reason_id" id="ddReasonId" class="form-control" v-model="ddReasonId">
                <option v-for="(reasonText, reasonId) in reasons" :value="reasonId">{{ reasonText }}</option>
              </select>
              <div v-if="(ddReasonId > 0) && (reasons[ddReasonId] == null)" class="text-warning">An invalid or inactive reason has been loaded. Please select a new reason.</div>
            </div>
          </div>

          <!-- Custom task text -->
          <div v-if="showCustomReasonField" class="form-group row">
            <label for="text" class="col-sm-3 col-form-label">Reason Text</label>
            <div class="col-sm-9">
              <textarea name="dd_reason" class="form-control" v-model="ddReason" rows="2"></textarea>
            </div>
          </div>

        </template>

        <input type="hidden" name="_method" value="PATCH">
        <input type="hidden" name="_token" :value="$csrf_token">
      </form>

      <template v-slot:footer>
        <button type="button" class="btn btn-white" @click="hideModal">Close</button>
        <button type="submit" name="button_submit_diary_date" class="btn btn-primary" :disabled="!isValid" :form="formId">
          <i class="fa fa-fw fa-save"></i> Save
        </button>
      </template>

    </modal>
  </div>
</template>

<script>
import HasModal from "./mixins/HasModal";
const DATE_FORMAT = 'MM/DD/YYYY';

export default {
  mixins: [HasModal],

  props: {
    // Current stored diary date.
    diary_date: {
      type: String,
      default: ""
    },

    // Form action.
    action: {
      type: String,
      default: ""
    },

    // Custom id for modal component.
    modalId: {
      type: String,
      default: 'setDiaryDateModal'
    },

    // Diary date change reason list keyed by id.
    ddReasons: {
      type: Object,
      default: () => {}
    },
  },

  data() {
    return {
      date: '',
      dayOptions: [7, 14, 21, 30, 45, 60],
      newDate: '',
      enableDatePicker: false,
      ddReasonId: null,
      ddReason: '',
    }
  },
  methods: {
    /**
     * Init form and show modal dialog.
     */
    initAndShow() {
      this.date = '';
      this.newDate = '';
      this.enableDatePicker = false;

      this.showModal();
    },
    setDate(date) {
      if (date) {
        this.date = moment(date, DATE_FORMAT).format(DATE_FORMAT);
        this.newDate = date;
        this.enableDatePicker = false;
      }
    },
    selectDate() {
      this.setDate(this.newDate);
    },
    addDays(days) {
      var calculatedDate = moment(new Date()).add(days, 'days').format(DATE_FORMAT);
      this.setDate(calculatedDate);
      this.enableDatePicker = false;
    },
    activateDatePicker() {
      this.enableDatePicker = true;
      this.$nextTick(function () {
        this.$refs.datepicker.openMenu();
      });
    },
    /**
     * Submit form data
     */
    submit(e) {
      if (this.isValid) {
        return true;
      } else {
        e.preventDefault();
      }
    },
    /**
     * Validate form
     */
    validate() {
      this.isValid = this.date;
      if (this.isValid) this.isValid = !this.enableDatePicker;
    },
  },

  computed: {

    minDate() {
      return moment(new Date()).set({hour:0,minute:0,second:0,millisecond:0}).format(DATE_FORMAT);
    },

    formId() {
      return 'diary-date-form';
    },

    isValid() {
      let isValid = (this.date.length > 0) && !this.enableDatePicker;
      if (isValid && this.diary_date.length > 0) {
        if (this.ddReasonId === null) {
          isValid = false;
        } else {
          if ((this.ddReasonId === -1) || (this.ddReasonId === '-1')) {
            isValid = this.ddReason.trim().length > 0;
          }
        }
      }
      return isValid;
    },

    // Diary date change reasons and "other" option.
    reasons() {
      let reasons = this.ddReasons;
      reasons[-1] = 'Other';
      return reasons;
    },

    // Selected diary date change reason.
    reason() {
      return this.ddReasonId;
    },

    // Show custom reason field if "Other" reason selected.
    showCustomReasonField() {
      return (this.ddReasonId === -1) || (this.ddReasonId === '-1');
    },

  },
}
</script>

<style scoped>
.btn:focus, .btn.focus {
  outline: none;
}

[data-toggle=buttons] > .btn input[type=radio], [data-toggle=buttons] > .btn-static input[type=radio], [data-toggle=buttons] > .btn input[type=checkbox], [data-toggle=buttons] > .btn-static input[type=checkbox], [data-toggle=buttons] > .btn-group > .btn input[type=radio], [data-toggle=buttons] > .btn-group > .btn input[type=checkbox] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}

.col-form-label {
  padding: 7px 0 0 0;
}

</style>
